import { NopeObject } from './NopeObject.js';
import { NopeString } from './NopeString.js';
import { NopeNumber } from './NopeNumber.js';
import { NopeBoolean } from './NopeBoolean.js';
import { NopeArray } from './NopeArray.js';
import { NopeDate } from './NopeDate.js';
import { NopeReference } from './NopeReference.js';

const object = () => new NopeObject();
const string = () => new NopeString();
const number = (message) => new NopeNumber(message);
const boolean = () => new NopeBoolean();
const date = (message) => new NopeDate(message);
const array = () => new NopeArray();
const ref = (key) => new NopeReference(key);
const Nope = {
    object,
    string,
    number,
    boolean,
    date,
    array,
    ref,
};

export { Nope, array, boolean, date, Nope as default, number, object, ref, string };
//# sourceMappingURL=index.js.map
